const getCitiesNames = (cities) => {
  return Array.isArray(cities)
    ? cities.map((city) => city.city_name || '').join(', ')
    : '';
};

export default getCitiesNames;
